import UploadDiscount from './UploadDiscount';

export default UploadDiscount;
